export default {
  title: "Change password",
  modal: {
    title: "Change password",
    form: {
      old_password: {
        label: "Old password",
        placeholder: "Enter old password",
      },
      new_password: {
        label: "New password",
        placeholder: "Enter new password",
      },
      repeat_new_password: {
        label: "Repeat new password",
        placeholder: "Repeat new password",
      },
      button: {
        close: "Close",
        save: "Save"
      },
    },
  },
}
